import SuiteLoginTip from './SuiteLoginTip';

export default SuiteLoginTip;
